import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_TableList = _resolveComponent("TableList")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "物料类别", -1)),
        _createVNode(_component_el_select, {
          filterable: true,
          modelValue: _ctx.listQuery.materialClassId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.materialClassId) = $event)),
          class: "filter-item",
          placeholder: "",
          clearable: "",
          size: _ctx.t('table.btnSize'),
          onChange: _ctx.handleFilter
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materialClassOption, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "size", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "名称", -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.listQuery.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.name) = $event)),
          style: {"width":"200px"},
          size: _ctx.t('table.btnSize'),
          class: "filter-item",
          clearable: "",
          onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
        }, null, 8, ["modelValue", "size", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "品牌", -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.listQuery.brand,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.brand) = $event)),
          style: {"width":"200px"},
          size: _ctx.t('table.btnSize'),
          class: "filter-item",
          clearable: "",
          onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
        }, null, 8, ["modelValue", "size", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "型号", -1)),
        _createVNode(_component_el_input, {
          modelValue: _ctx.listQuery.model,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.model) = $event)),
          style: {"width":"200px"},
          size: _ctx.t('table.btnSize'),
          class: "filter-item",
          clearable: "",
          onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
        }, null, 8, ["modelValue", "size", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: "filter-item",
          type: "primary",
          size: _ctx.t('table.btnSize'),
          onClick: _ctx.handleFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
          ]),
          _: 1
        }, 8, ["size", "onClick"])), [
          [_directive_waves]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: "filter-item",
          type: "primary",
          size: _ctx.t('table.btnSize'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleCommand('add')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
          ]),
          _: 1
        }, 8, ["size"])), [
          [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: "filter-item",
          size: _ctx.t('table.btnSize'),
          onClick: _ctx.handleReset
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
          ]),
          _: 1
        }, 8, ["size", "onClick"])), [
          [_directive_waves]
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_TableList, {
      ref: "TableList",
      dataList: _ctx.list,
      total: _ctx.total,
      page: _ctx.listQuery.page,
      size: _ctx.listQuery.size,
      columnAllData: _ctx.columnAllData,
      tableName: _ctx.TableName,
      permissionName: _ctx.permissionName,
      showSelection: true,
      canCommand: false,
      canChangeColumn: false,
      onCommandChange: _ctx.handleCommand
    }, {
      max: _withCtx((scope) => [
        _createElementVNode("span", null, [
          (scope.row.max)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "dark",
                placement: "top-start"
              }, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.max?.supplier?.name), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.max?.updateTime), 1)
                ]),
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("i", {
                    class: "iconfont icon-tubiao-30",
                    style: {"font-size":"14px"}
                  }, null, -1))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row, 'max')), 1)
        ])
      ]),
      min: _withCtx((scope) => [
        _createElementVNode("span", null, [
          (scope.row.min)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "dark",
                placement: "top-start"
              }, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.max?.supplier?.name), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.min?.updateTime), 1)
                ]),
                default: _withCtx(() => [
                  _cache[12] || (_cache[12] = _createElementVNode("i", {
                    class: "iconfont icon-tubiao-30",
                    style: {"font-size":"14px"}
                  }, null, -1))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row, 'min')), 1)
        ])
      ]),
      _: 1
    }, 8, ["dataList", "total", "page", "size", "columnAllData", "tableName", "permissionName", "onCommandChange"])), [
      [_directive_loading, _ctx.listLoading]
    ])
  ]))
}